<template>
  <div
    class="bg-warning-100 text-warning-600 text-xs text-center px-2 py-1 lg:rounded-b-lg"
  >
    <p v-if="note">
      {{ note }}
    </p>
    <p v-else>
      {{ $t("minimum_cart_value_message") }}:
      <Amount :value="amount" class="font-medium" />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    amount: { type: Number, default: null },
    note: { type: String, default: null },
  },
};
</script>
